export const CUSTOMER_LIST_PAGE_SIZE_OPTIONS = [50, 100, 250, 500];
export const DEFAULT_CUSTOMER_LIST_PAGE_SIZE = 50;
